$(function () {

	//ページ内スクロール
	$.smooziee();

	$('.animate').scrolla({
		mobile: true, // モバイルの有効・無効
		once: false // 発火は１度だけか、視界に入るたびに発火させるか
	});

	//アコーディオン
	$(".acd_head").on("click", function() {
		$(this).toggleClass('open');
		$(this).next().slideToggle();
	});

	//アコーディオン（特徴）
	$(".toggle_ttl").on("click", function() {
		$(this).toggleClass('open');
		$(this).next().toggleClass('open');
		$(this).next().slideToggle();
	});

	//アコーディオン（フレックス）
	$(".toggle_ttl_flex").on("click", function() {
		$(this).toggleClass('open');
		$(this).next().toggleClass('open');
		// $(this).next().slideToggle();
	});


	//タブ切り替え
	// $('.tab_box .tab_btn').click(function() {
	// 	var index = $('.tab_box .tab_btn').index(this);
	// 	$('.tab_box .tab_btn, .tab_box .tab_panel').removeClass('active');
	// 	$(this).addClass('active');
	// 	$('.tab_box .tab_panel').eq(index).addClass('active');
	// });

	//タブ切り替え（スマホのみ）
	// function spTab() {
	// 	$('.tab_box_sp .tab_btn').click(function() {
	// 		var index = $('.tab_box_sp .tab_btn').index(this);
	// 		$('.tab_box_sp .tab_btn, .tab_box_sp .tab_panel').removeClass('active');
	// 		$(this).addClass('active');
	// 		$('.tab_box_sp .tab_panel').eq(index).addClass('active');
	// 	});
	// }

	//タブ切り替え（下層共通）
	$(".tab_btn").on("click",function(){
		var $th = $(this).index();
		$(this).parent().find(".tab_btn").removeClass("active");
		$(this).parent().next().find(".tab_panel").removeClass("active");
		$(this).addClass("active");
		$(this).parent().next().find(".tab_panel").eq($th).addClass("active");
	});

	//アコーディオン（CYBER BOXページ 上に展開ver）
	$(".toggle_ttl_prev").on("click", function() {
		if($(this).hasClass('open')){
			$(this).removeClass("open");
			$(this).prev().removeClass("open");
			// $(this).prev().slideToggle();
			$(this).find(".toggle_ttl_prev_text").html("続きを読む");
			var position = $(this).prev().offset().top;
			// console.log(position);
			$("html,body").animate({
				scrollTop : position - 280 //スクロール位置調整
			});
		} else {
			$(this).toggleClass("open");
			$(this).prev().toggleClass("open");
			// $(this).prev().slideToggle();
			$(this).find(".toggle_ttl_prev_text").html("CLOSE");
		}
	});

	$(window).on('load resize', function(){
		var w = $(window).width();
		if (w <= 768) {
			//スマホのみ
			spTab();
		} else {
			//PCのみ
		}
	});

	//スマホ時横スクロールバー
	// var ps = new PerfectScrollbar('.scroll_inner');

	//ポップアップ
	$('.popup-modal-img').magnificPopup({
		type: 'image', 
	});

	//flowページ数字色変更
	// $(window).scroll(function () {
	// 	$('.flow_step01').each(function () {
	// 		var hit = $(this).offset().top;
	// 		var scroll = $(window).scrollTop();
	// 		var wHeight = $(window).height();
	// 		var customTop = 200;
	// 		if (typeof $(this).data('flow_step01') !== 'undefined') {
	// 			customTop = $(this).data('flow_step01');
	// 		}
	// 		if (hit + customTop < wHeight + scroll) {
	// 			$(this).addClass("active");
	// 		} else {
	// 			$(this).removeClass("active");
	// 	}
	// 	});
	// });

	//2025追記 診断ページ
	if($('.diagnose2025').length){

		//特徴 スライドショー
		var diagnose2025_features_swiper = new Swiper(".diagnose2025_features_swiper", {
			slidesPerView: 'auto',
			spaceBetween: 20,
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
			breakpoints: {
				// 768px以上（PC・タブレット）でSwiperを無効化
				768: {
					enabled: false,
					slidesPerView: 'auto',
					spaceBetween: 0,
				}
			}
		});

		//声 スライドショー
		var diagnose2025_voice_swiper = new Swiper(".diagnose2025_voice_swiper", {
			// loop: true,
			slidesPerView: 'auto',
			// centeredSlides: true,
			// autoplay: {
			// 	delay: 3000,
			// },
			breakpoints: {
				0: {
					spaceBetween: 20, // 0px以上（スマホ）
				},
				768: {
					spaceBetween: 50, // 768px以上（PC）
				}
        	},
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			}
		});

		//アコーディオン（FAQ）
		$(".diagnose2025_faq_question").on("click", function() {
			$(this).toggleClass('open');
			$(this).next().toggleClass('open');
			$(this).next().slideToggle();
		});	

		//特徴クラスの付け替え
		$(document).ready(function() {
			var $window = $(window);
			var $body = $('body');
			var $blocks = $('.diagnose2025_features_blocks_block');
			var windowHeight = $window.height();
			var currentActiveClass = '';
			var allFeatureClasses = [];
			
			// 初期化：ブロック数に応じてクラス名を動的生成
			function initializeClasses() {
				allFeatureClasses = [];
				$blocks.each(function(index) {
					var classNumber = String(index + 1).padStart(2, '0');
					allFeatureClasses.push('features-show-' + classNumber);
				});
			}
			
			// スクロール処理
			function handleScroll() {
				var scrollTop = $window.scrollTop();
				var triggerPoint = scrollTop + (windowHeight * 0.8);
				var newActiveClass = '';
				
				$blocks.each(function(index) {
					var blockOffset = $(this).offset().top;
					
					if (triggerPoint >= blockOffset) {
						newActiveClass = allFeatureClasses[index];
					}
				});
				
				// クラスが変更された場合のみDOM操作
				if (newActiveClass !== currentActiveClass) {
					// 既存のfeatures-showクラスをすべて削除
					$body.removeClass(allFeatureClasses.join(' '));
					if (newActiveClass) {
						$body.addClass(newActiveClass);
					}
					currentActiveClass = newActiveClass;
				}
			}
			
			// 初期化
			initializeClasses();
			
			// イベントリスナー
			$window.on('scroll', handleScroll);
			$window.on('resize', function() {
				windowHeight = $window.height();
			});
			
			// 初期チェック
			handleScroll();
			
			// DOM変更を監視（オプション：ブロックが動的に追加/削除される場合）
			if (window.MutationObserver) {
				var observer = new MutationObserver(function(mutations) {
					mutations.forEach(function(mutation) {
						if (mutation.type === 'childList') {
							// ブロック要素の変更を検知
							var newBlocks = $('.diagnose2025_features_blocks_block');
							if (newBlocks.length !== $blocks.length) {
								$blocks = newBlocks;
								initializeClasses();
								handleScroll();
							}
						}
					});
				});
				
				observer.observe(document.querySelector('.diagnose2025_features_blocks_txts'), {
					childList: true,
					subtree: true
				});
			}
		});

	}

});